export default function Stepper({ steps, currentStep }) {
  return (
    <ol
      className="
        flex 
        flex-row justify-between items-center 
        gap-4 
        md:flex-col md:items-start md:gap-6 md:w-60
      "
    >
      {steps.map((step, index) => {
        const currentIndex = steps.findIndex(s => s.id === currentStep);
        const stepIndex = steps.findIndex(s => s.id === step.id);

        const isActive = step.id === currentStep;
        const isCompleted = stepIndex < currentIndex;

        return (
          <li
            key={step.id}
            className="relative flex flex-col items-center md:flex-row md:items-start"
          >
            {/* CIRCLE */}
            <div
              className={[
                "flex items-center justify-center w-8 h-8 rounded-full border text-sm font-medium shrink-0 transition-all duration-300",
                isActive
                  ? "bg-blue-600 text-white border-blue-600"
                  : isCompleted
                  ? "bg-blue-100 text-blue-700 border-blue-600"
                  : "bg-white text-slate-400 border-slate-300",
              ].join(" ")}
            >
              {/* ✅ SHOW UI NUMBER, NOT BACKEND ID */}
              {isCompleted ? "✓" : step.displayIndex}
            </div>

            {/* Name */}
            <p
              className={`hidden md:block ml-3 text-sm font-medium ${
                isActive
                  ? "text-blue-600"
                  : isCompleted
                  ? "text-blue-700"
                  : "text-slate-600"
              }`}
            >
              {step.name}
            </p>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div
                className="
                  bg-slate-300 absolute 
                  w-full h-[2px] top-4 left-8 
                  md:w-[2px] md:h-full md:left-3 md:top-8
                "
              ></div>
            )}
          </li>
        );
      })}
    </ol>
  );
}



// export default function Stepper({ steps, currentStep }) {
//   return (
//     <ol className="flex flex-col md:flex-col items-start md:items-start gap-6 w-full md:w-60 
//                    sm:flex-row sm:items-center sm:gap-4 sm:justify-between">
//       {steps.map((step, index) => {
//         const isActive = currentStep === step.id;
//         const isCompleted = currentStep > step.id;

//         return (
//           <li key={step.id} className="relative flex sm:flex-col md:flex-row items-start sm:items-center">
            
//             {/* CIRCLE */}
//             <div
//               className={[
//                 "flex items-center justify-center w-8 h-8 rounded-full border text-sm font-medium shrink-0 transition-all duration-300",
//                 isActive
//                   ? "bg-blue-600 text-white border-blue-600"
//                   : isCompleted
//                   ? "bg-blue-100 text-blue-700 border-blue-600"
//                   : "bg-white text-slate-400 border-slate-300",
//               ].join(" ")}
//             >
//               {isCompleted ? "✓" : step.id}
//             </div>

//             {/* Step Name (hidden on small screens, visible from md and above) */}
//             <p
//               className={`ml-3 text-sm font-medium mt-0.5 hidden md:block ${
//                 isActive
//                   ? "text-blue-600"
//                   : isCompleted
//                   ? "text-blue-700"
//                   : "text-slate-600"
//               }`}
//             >
//               {step.name}
//             </p>

//             {/* Connector Line */}
//             {index < steps.length - 1 && (
//               <div className="
//                 absolute md:left-3 md:top-8 sm:left-8 sm:top-4
//                 bg-slate-300
//                 md:w-[2px] md:h-full
//                 sm:h-[2px] sm:w-full
//               "></div>
//             )}
//           </li>
//         );
//       })}
//     </ol>
//   );
// }


// export default function Stepper({ steps, currentStep }) {
//   return (
//     <ol className="flex flex-col md:flex-col items-start gap-6 w-60"> {/* Sidebar width */}
//       {steps.map((step, index) => {
//         const isActive = currentStep === step.id;
//         const isCompleted = currentStep > step.id;

//         return (
//           <li key={step.id} className="relative flex items-start">
//             {/* CIRCLE */}
//             <div
//               className={[
//                 "flex items-center justify-center w-8 h-8 rounded-full border text-sm font-medium shrink-0 transition-all duration-300",
//                 isActive
//                   ? "bg-blue-600 text-white border-blue-600"
//                   : isCompleted
//                   ? "bg-blue-100 text-blue-700 border-blue-600"
//                   : "bg-white text-slate-400 border-slate-300",
//               ].join(" ")}
//             >
//               {isCompleted ? "✓" : step.id}
//             </div>

//             {/* Step Name */}
//             <p
//               className={`ml-3 text-sm font-medium mt-0.5 ${
//                 isActive
//                   ? "text-blue-600"
//                   : isCompleted
//                   ? "text-blue-700"
//                   : "text-slate-600"
//               }`}
//             >
//               {step.name}
//             </p>

//             {/* Vertical Connector Line */}
//             {index < steps.length - 1 && (
//               <div
//                 className="absolute left-3 top-8 w-[2px] h-full bg-slate-300"
//               ></div>
//             )}
//           </li>
//         );
//       })}
//     </ol>
//   );
// }
  


// export default function Stepper({ steps, currentStep }) {
//   return (
//     <ol className="flex flex-row items-center justify-between w-full mb-6 md:mb-8 md:flex-row gap-0">
//       {steps.map((step, index) => {
//         const isActive = currentStep === step.id;
//         const isCompleted = currentStep > step.id;

//         return (
//           <li key={step.id} className="flex flex-col items-center w-full relative">

//             {/* CIRCLE */}
//             <div
//               className={[
//                 "flex items-center justify-center w-8 h-8 rounded-full border text-sm font-medium shrink-0 transition-all duration-300",
//                 isActive
//                   ? "bg-blue-600 text-white border-blue-600"
//                   : isCompleted
//                   ? "bg-blue-100 text-blue-700 border-blue-600"
//                   : "bg-white text-slate-400 border-slate-300",
//               ].join(" ")}
//             >
//               {isCompleted ? "✓" : step.id}
//             </div>

//             {/* Step Name - Hidden on Mobile */}
//             <p
//               className={`hidden md:block text-sm font-medium mt-1 ${
//                 isActive
//                   ? "text-blue-600"
//                   : isCompleted
//                   ? "text-blue-700"
//                   : "text-slate-600"
//               }`}
//             >
//               {step.name}
//             </p>

//             {/* Horizontal Connector Line (Mobile + Desktop) */}
//             {index < steps.length - 1 && (
//               <div className="absolute top-1/2 left-full w-full h-[2px] bg-slate-300 hidden md:block"></div>
//             )}

//             {/* MOBILE LINE */}
//             {index < steps.length - 1 && (
//               <div className="absolute top-1/2 left-full w-[30px] h-[2px] bg-slate-300 md:hidden"></div>
//             )}
//           </li>
//         );
//       })}
//     </ol>
//   );
// }




// export default function Stepper({ steps, currentStep }) {
//   return (
//     <ol className="flex flex-col md:flex-row items-center gap-4 md:gap-0 mb-6 md:mb-8">
//       {steps.map((step, index) => {
//         const isActive = currentStep === step.id;
//         const isCompleted = currentStep > step.id;

//         return (
//           <li
//             key={step.id}
//             className="flex flex-col md:flex-row items-center md:items-center w-full md:w-auto relative"
//           >
//             {/* STEP CIRCLE */}
//             <div
//               className={[
//                 "flex items-center justify-center w-8 h-8 rounded-full border text-sm font-medium shrink-0 transition-all duration-300",
//                 isActive
//                   ? "bg-blue-600 text-white border-blue-600"
//                   : isCompleted
//                   ? "bg-blue-100 text-blue-700 border-blue-600"
//                   : "bg-white text-slate-400 border-slate-300",
//               ].join(" ")}
//             >
//               {isCompleted ? "✓" : step.id}
//             </div>

//             {/* STEP NAME (Desktop Visible Always, Mobile Only Active) */}
//             <p
//               className={`text-sm font-medium mt-1 md:mt-0 md:ml-2 transition ${
//                 isActive
//                   ? "text-blue-600"
//                   : isCompleted
//                   ? "text-blue-700"
//                   : "text-slate-600"
//               } ${
//                 // hide on mobile if not active
//                 isActive ? "block" : "hidden md:block"
//               }`}
//             >
//               {step.name}
//             </p>

//             {/* Connector line for Desktop */}
//             {index < steps.length - 1 && (
//               <div className="hidden md:block flex-1 h-[2px] bg-slate-200 mx-4"></div>
//             )}
//           </li>
//         );
//       })}
//     </ol>
//   );
// }



// export default function Stepper({ steps, currentStep }) {
//   return (
//     <ol className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-0 mb-6 md:mb-8">
//       {steps.map((step, index) => {
//         const isActive = currentStep === step.id;
//         const isCompleted = currentStep > step.id;

//         return (
//           <li
//             key={step.id}
//             className="flex items-start md:items-center w-full md:w-auto relative"
//           >
//             {/* Step Icon + Label */}
//             <div className="flex items-center gap-2 md:gap-3">
//               <div
//                 className={[
//                   "flex items-center justify-center w-8 h-8 rounded-full border text-sm font-medium shrink-0 transition-all duration-300",
//                   isActive
//                     ? "bg-blue-600 text-white border-blue-600"
//                     : isCompleted
//                     ? "bg-blue-100 text-blue-700 border-blue-600"
//                     : "bg-white text-slate-400 border-slate-300",
//                 ].join(" ")}
//               >
//                 {isCompleted ? "✓" : step.id}
//               </div>

//               <p
//                 className={`text-sm font-medium ${
//                   isActive
//                     ? "text-blue-600"
//                     : isCompleted
//                     ? "text-blue-700"
//                     : "text-slate-600"
//                 }`}
//               >
//                 {step.name}
//               </p>
//             </div>

//             {/* Connector Line for Desktop */}
//             {index < steps.length - 1 && (
//               <div className="hidden md:block flex-1 h-[2px] bg-slate-200 mx-4"></div>
//             )}

//             {/* Vertical Connector Line for Mobile */}
//             {index < steps.length - 1 && (
//               <div className="block md:hidden absolute left-[16px] top-[40px] w-[2px] h-6 bg-slate-300"></div>
//             )}
//           </li>
//         );
//       })}
//     </ol>
//   );
// }



// export default function Stepper({ steps, currentStep }) {
//   return (
//     <ol className="flex items-center justify-between mb-6 md:mb-8">
//       {steps.map((step, index) => {
//         const isActive = currentStep === step.id;
//         const isCompleted = currentStep > step.id;

//         return (
//           <li key={step.id} className="flex-1 flex items-center">
//             <div className="flex items-center">
//               <div
//                 className={[
//                   "flex items-center justify-center w-8 h-8 rounded-full border text-sm font-medium",
//                   isActive
//                     ? "bg-blue-600 text-white border-blue-600"
//                     : isCompleted
//                     ? "bg-blue-100 text-blue-700 border-blue-600"
//                     : "bg-white text-slate-400 border-slate-200",
//                 ].join(" ")}
//               >
//                 {isCompleted ? "✓" : step.id}
//               </div>
//               <div className="ml-2">
//                 {/* <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">
//                   Step {step.id}
//                 </p> */}
//                 <p className="text-sm text-slate-800">{step.name}</p>
//               </div>
//             </div>
//             {index < steps.length - 1 && (
//               <div className="hidden md:block flex-1 h-px mx-4 bg-slate-200" />
//             )}
//           </li>
//         );
//       })}
//     </ol>
//   );
// }